import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { HorizontalMenu } from '../../../../shared/horizontal-menu/HorizontalMenu';

class RiskAssessmentMenu extends Component {
    render() {
        return (
            <HorizontalMenu>
                <NavLink
                    className="horizontal-menu-item"
                    to="/risk-assessment/anti-money-laundering"
                >
                    AML
                </NavLink>
                <NavLink
                    className="horizontal-menu-item"
                    to="/risk-assessment/fraud"
                >
                    Fraud
                </NavLink>
                <NavLink
                    className="horizontal-menu-item"
                    to="/risk-assessment/responsible-gambling"
                >
                    RG
                </NavLink>
            </HorizontalMenu>
        );
    }
}

export default RiskAssessmentMenu; // todo [mandy] extract this as one ... AlertsMenu ... named Risk Categories Menu.
